import React from 'react';
import { useIntl } from 'react-intl';
import FieldChange from './FieldChange';
import EnumChange from './EnumChange';
import messages from './FieldMessages';

const RelationLinkProperty = props => {
  const intl = useIntl();
  const { log, relations, users } = props;

  const isEnum = () => {
    const value = log.oldValue.Value || log.newValue.Value;
    return value && value.hasOwnProperty('Value') && value.hasOwnProperty('Name');
  };

  const displayLogLine = () => {
    const transformedLogLine = {
      ...log,
      oldValue: log.oldValue.Value,
      newValue: log.newValue.Value,
    };

    if (isEnum()) {
      return <EnumChange log={transformedLogLine} />;
    }

    return <FieldChange log={transformedLogLine} users={users} relations={relations} />;
  };

  const relation = relations[log.oldValue.RelationId];

  return (
    <span>
      {displayLogLine(log.newValue)}{' '}
      {intl.formatMessage(messages.ForRelationLinkWith, { relation })}
    </span>
  );
};

export default RelationLinkProperty;
